import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'colors',
    standalone: true
})
export class ColorsPipe implements PipeTransform {
  transform(item: any, type:string='') {
    switch(type){
      case 'icon-filter-list':
        return this.progressColors(item);
      case 'icon-table-list':
        return this.progressTableColors(item);
      case 'documentStatusId':
        return this.documentStatusColors(item);
      case 'highlightListColors':
        let configuredItem: any = typeof item === 'string'?item.toUpperCase():item;
        return this.highlightListColors(configuredItem);
      default:
        return this.defaultColors(item);
    }
  }

  defaultColors(item: any=''){
    switch(item){
      case 1: //'Abierta'
      case 'Sin empezar':
      case '#c43741':
        return 'red';
      case 2: //'Stand by'
      case 'Descartada':
      case 'Atrasado':
      case '#f1923e':
        return 'orange';
      case 3: //'En progreso'
      case 'En proceso':
      case 'progress':
      case '#f1bc3e':
        return 'yellow';
      case 5://'Cerrada'
        return 'grey';
      case 6://'Cerrada sin resolver'
        return 'brown';
      case 7://'Tarea de proceso'
        return 'blue';
      case '':
        return 'empty';
      case '#c43741':
      default:
        return 'green';
    }
  }

  progressColors(item:any=''){
    switch(item){
      case 'started':
      case '3-more-time':
        return 'red';
      case 'in-progress':
      case '2-two-days':
        return 'yellow';
      case 'advanced':
      case '1-last-day':
        return 'green';
      default:
        return 'grey';
    }
  }

  progressTableColors(item:any=''){
    switch(item){
      // case 'started':
      case '3-more-time':
      case 'red':
        return 'red-100';
      // case 'in-progress':
      case '2-two-days':
      case 'yellow':
        return 'yellow-100';
      // case 'advanced':
      case '1-last-day':
      case 'green':
        return 'green-100';
      default:
        return 'grey-050';
    }
  }

  documentStatusColors(item: any=''){
    switch(item){
      case 2://Publicado
        return 'blue';
      case 3://Proceso de firma
        return 'yellow';
      case 4://Firmado
      case 6://Certificado
        return 'green';
      default://Borrador
        return 'grey';
    }
  }

  highlightListColors(item: any=''){
    switch(item){
      case 1:
      case '#5EC6DD':
      case '#8298E6':
        return 'blue';
      case 2:
      case '#7683B5':
      case '#768FC2':
        return 'marian-blue';
      case 3:
      case '#77D166':
      case '#59AC85':
        return 'green-100';
      case 4:
      case '#7A58AC':
      case '#99E6D8':
        return 'tiffany-blue';
      case 5:
      case '#929B9C':
      case '#B2B4B2':
        return 'grey';
      case 6:
      case '#9A7E74':
      case '#D8B982':
        return 'brown';
      case 7:
      case '#C43741':
      case '#E16668':
        return 'red-100';
      case 8:
      case '#E5869D':
      case '#D9C756':
        return 'citron';
      case 9:
      case '#F1923E':
      case '#FFB759':
        return 'orange';
      case 10:
      case '#F1BC3E':
      case '#F5D359':
        return 'yellow-100';
      default:
        return 'green-100';
    }
  }
}
